import { motion } from "framer-motion";
import { Star, ArrowUpRight, Eye, Heart } from "lucide-react";

export const ProductCard = ({ product, featured = false, index = 0, onQuickView, isFavorite = false, onToggleFavorite }) => (
  <motion.article
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.6, delay: (index % 4) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    whileHover={{ scale: 1.02 }}
    className={`group relative flex flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#121418] transition-[border-color,box-shadow] duration-300 hover:border-[#FF9900]/40 hover:shadow-[0_0_40px_rgba(255,153,0,0.12)] ${
      featured ? "md:col-span-2 md:row-span-2" : ""
    }`}
    data-testid={`product-card-${product.id}`}
  >
    <div className={`relative overflow-hidden ${featured ? "h-72 md:h-96" : "h-52"}`}>
      <img
        src={product.image}
        alt={product.title}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0C0E]/80 via-transparent to-transparent" />
      <span className="absolute left-3 top-3 rounded-full bg-black/60 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-[#FFB800] backdrop-blur-md">
        {product.badge}
      </span>
      <div className="absolute right-3 top-3 flex gap-2">
        <button
          data-testid={`product-favorite-btn-${product.id}`}
          onClick={() => onToggleFavorite(product)}
          aria-label={`${isFavorite ? "Remove" : "Add"} ${product.title} ${isFavorite ? "from" : "to"} wishlist`}
          className={`rounded-full border border-white/10 bg-black/60 p-2 backdrop-blur-md transition-all duration-200 hover:bg-[#FF9900] hover:text-[#0B0C0E] ${
            isFavorite ? "text-[#FF9900] opacity-100" : "text-slate-200 opacity-0 group-hover:opacity-100"
          }`}
        >
          <Heart size={15} className={isFavorite ? "fill-[#FF9900]" : ""} />
        </button>
        <button
          data-testid={`product-quick-view-btn-${product.id}`}
          onClick={() => onQuickView(product)}
          aria-label={`Quick view ${product.title}`}
          className="rounded-full border border-white/10 bg-black/60 p-2 text-slate-200 opacity-0 backdrop-blur-md transition-all duration-200 hover:bg-[#FF9900] hover:text-[#0B0C0E] group-hover:opacity-100"
        >
          <Eye size={15} />
        </button>
      </div>
    </div>
    <div className="flex flex-1 flex-col gap-2 p-5">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{product.category}</p>
      <h3 className="font-display text-lg font-semibold tracking-tight text-slate-50">{product.title}</h3>
      <div className="flex items-center gap-1.5 text-xs text-slate-400">
        <Star size={12} className="fill-[#FF9900] text-[#FF9900]" />
        <span className="font-mono font-semibold text-slate-200">{product.rating}</span>
        <span>({Number(product.reviews).toLocaleString()} reviews)</span>
      </div>
      <div className="mt-auto flex items-center justify-between pt-3">
        <span className="font-mono text-xl font-bold text-[#FF9900]">{product.price}</span>
        <a
          data-testid={`product-buy-amazon-btn-${product.id}`}
          href={product.link}
          target="_blank"
          rel="noopener noreferrer sponsored"
          className="inline-flex items-center gap-1.5 rounded-full border border-[#FF9900]/40 px-4 py-2 text-xs font-bold text-[#FFB800] transition-all duration-200 hover:bg-[#FF9900] hover:text-[#0B0C0E] active:scale-95"
        >
          Buy on Amazon
          <ArrowUpRight size={13} />
        </a>
      </div>
    </div>
  </motion.article>
);
